$ = jQuery;
import {_} from 'underscore';

export const CardJs = {
    KEYS: {
        "0": 48,
        "9": 57,
        "NUMPAD_0": 96,
        "NUMPAD_9": 105,
        "DELETE": 46,
        "BACKSPACE": 8,
        "ARROW_LEFT": 37,
        "ARROW_RIGHT": 39,
        "ARROW_UP": 38,
        "ARROW_DOWN": 40,
        "HOME": 36,
        "END": 35,
        "TAB": 9,
        "A": 65,
        "X": 88,
        "C": 67,
        "V": 86
    },
    cardInfo: {
        'Diners - Carte Blanche': {
            mask: "XXXX XXXX XXXX XX",
            iconClass: 'diners',
            cvcMAsk: "XXX"
        },
        'Diners': {
            mask: "XXXX XXXX XXXX XX",
            iconClass: 'diners',
            cvcMAsk: "XXX"
        },
        'JCB': {
            mask: "XXXX XXXX XXXX XXXX",
            iconClass: 'jcb',
            cvcMAsk: "XXX"
        },
        'AMEX': {
            mask: "XXXX XXXXXX XXXXX",
            iconClass: 'american-express',
            cvcMAsk: "XXXX"
        },
        'Visa Electron': {
            mask: "XXXX XXXX XXXX XXXX",
            iconClass: 'visa',
            cvcMAsk: "XXX"
        },
        'Visa': {
            mask: "XXXX XXXX XXXX XXXX",
            iconClass: '',
            cvcMAsk: "XXX"
        },
        'Mastercard': {
            mask: "XXXX XXXX XXXX XXXX",
            iconClass: 'master-card',
            cvcMAsk: "XXX"
        },
        'Discover': {
            mask: "XXXX XXXX XXXX XXXX",
            iconClass: 'discover',
            cvcMAsk: "XXX"
        },
    },
    CREDIT_CARD_NUMBER_DEFAULT_MASK: "XXXX XXXX XXXX XXXX",

    CREDIT_CARD_NUMBER_PLACEHOLDER: "Card number",
    NAME_PLACEHOLDER: "Name on card",
    EXPIRY_MASK: "XX / XX",
    EXPIRY_PLACEHOLDER: "MM / YY",
    EXPIRY_USE_DROPDOWNS: false,
    EXPIRY_NUMBER_OF_YEARS: 10,
    CVC_MASK_2: "XX",
    CVC_MASK_3: "XXX",
    CVC_MASK_4: "XXXX",
    CVC_PLACEHOLDER: "CVC",

    creditCardNumberMask: "XXXX XXXX XXXX XXXX",

    keyCodeFromEvent: function(e) {
        return e.which || e.keyCode;
    },

    keyIsDelete: function(e) {
        return CardJs.keyCodeFromEvent(e) == CardJs.KEYS["DELETE"];
    },

    keyIsBackspace: function(e) {
        return CardJs.keyCodeFromEvent(e) == CardJs.KEYS["BACKSPACE"];
    },

    keyIsDeletion: function(e) {
        return CardJs.keyIsDelete(e) || CardJs.keyIsBackspace(e);
    },

    keyIsArrow: function(e) {
        var keyCode = CardJs.keyCodeFromEvent(e);
        return keyCode >= CardJs.KEYS["ARROW_LEFT"] && keyCode <= CardJs.KEYS["ARROW_DOWN"];
    },

    keyIsNavigation: function(e) {
        var keyCode = CardJs.keyCodeFromEvent(e);
        return keyCode == CardJs.KEYS["HOME"] || keyCode == CardJs.KEYS["END"];
    },

    keyIsKeyboardCommand: function(e) {
        var keyCode = CardJs.keyCodeFromEvent(e);
        return CardJs.keyIsCommandFromEvent(e) &&
            (
                keyCode == CardJs.KEYS["A"] ||
                keyCode == CardJs.KEYS["X"] ||
                keyCode == CardJs.KEYS["C"] ||
                keyCode == CardJs.KEYS["V"]
            );
    },

    keyIsTab: function(e) {
        return CardJs.keyCodeFromEvent(e) == CardJs.KEYS["TAB"];
    },


    keyIsTopNumber: function(e) {
        var keyCode = CardJs.keyCodeFromEvent(e);
        return keyCode >= CardJs.KEYS["0"] && keyCode <= CardJs.KEYS["9"];
    },

    keyIsKeypadNumber: function(e) {
        var keyCode = CardJs.keyCodeFromEvent(e);
        return keyCode >= CardJs.KEYS["NUMPAD_0"] && keyCode <= CardJs.KEYS["NUMPAD_9"];
    },

    keyIsCommandFromEvent: function(e) {
        return e.ctrlKey || e.metaKey;
    },


    keyIsNumber: function(e) {
        return CardJs.keyIsTopNumber(e) || CardJs.keyIsKeypadNumber(e);
    },

    numbersOnlyString: function(string) {
        var numbersOnlyString = "";
        for( var i = 0; i < string.length; i++ ) {
            var currentChar = string.charAt(i);
            var isValid = !isNaN(parseInt(currentChar));
            if( isValid ) {
                numbersOnlyString += currentChar;
            }
        }
        return numbersOnlyString;
    },

    filterNumberOnlyKey: function(e) {
        var isNumber = CardJs.keyIsNumber(e);
        var isDeletion = CardJs.keyIsDeletion(e);
        var isArrow = CardJs.keyIsArrow(e);
        var isNavigation = CardJs.keyIsNavigation(e);
        var isKeyboardCommand = CardJs.keyIsKeyboardCommand(e);
        var isTab = CardJs.keyIsTab(e);

        if( !isNumber && !isDeletion && !isArrow && !isNavigation && !isKeyboardCommand && !isTab ) {
            e.preventDefault();
        }
    },

    caretStartPosition: function(element) {
        if( typeof element.selectionStart == "number" ) {
            return element.selectionStart;
        }
        return false;
    },

    caretEndPosition: function(element) {
        if( typeof element.selectionEnd == "number" ) {
            return element.selectionEnd;
        }
        return false;
    },

    normaliseCaretPosition: function(mask, caretPosition) {
        var numberPos = 0;
        if( caretPosition < 0 || caretPosition > mask.length ) {
            return 0;
        }
        for( var i = 0; i < mask.length; i++ ) {
            if( i == caretPosition ) {
                return numberPos;
            }
            if( mask[i] == "X" ) {
                numberPos++;
            }
        }
        return numberPos;
    },

    denormaliseCaretPosition: function(mask, caretPosition) {
        var numberPos = 0;
        if( caretPosition < 0 || caretPosition > mask.length ) {
            return 0;
        }
        for( var i = 0; i < mask.length; i++ ) {
            if( numberPos == caretPosition ) {
                return i;
            }
            if( mask[i] == "X" ) {
                numberPos++;
            }
        }
        return mask.length;
    },

    setCaretPosition: function(element, caretPos) {
        if( element != null ) {
            if( element.createTextRange ) {
                var range = element.createTextRange();
                range.move('character', caretPos);
                range.select();
            } else {
                if( element.selectionStart ) {
                    element.focus();
                    element.setSelectionRange(caretPos, caretPos);
                } else {
                    element.focus();
                }
            }
        }
    },

    applyFormatMask: function(string, mask) {
        var formattedString = "";
        var numberPos = 0;
        for( var j = 0; j < mask.length; j++ ) {
            var currentMaskChar = mask[j];
            if( currentMaskChar == "X" ) {
                var digit = string.charAt(numberPos);
                if( !digit ) {
                    break;
                }
                formattedString += string.charAt(numberPos);
                numberPos++;
            } else {
                formattedString += currentMaskChar;
            }
        }
        return formattedString;
    },

    digitFromKeyCode: function(keyCode) {

        if( keyCode >= CardJs.KEYS["0"] && keyCode <= CardJs.KEYS["9"] ) {
            return keyCode - CardJs.KEYS["0"];
        }

        if( keyCode >= CardJs.KEYS["NUMPAD_0"] && keyCode <= CardJs.KEYS["NUMPAD_9"] ) {
            return keyCode - CardJs.KEYS["NUMPAD_0"];
        }

        return null;
    },

    cardTypeFromNumber: function(number) {

        // Diners - Carte Blanche
        re = new RegExp("^30[0-5]");
        if( number.match(re) != null )
            return "Diners - Carte Blanche";

        // Diners
        re = new RegExp("^(30[6-9]|36|38)");
        if( number.match(re) != null )
            return "Diners";

        // JCB
        re = new RegExp("^35(2[89]|[3-8][0-9])");
        if( number.match(re) != null )
            return "JCB";

        // AMEX
        re = new RegExp("^3[47]");
        if( number.match(re) != null )
            return "AMEX";

        // Visa Electron
        re = new RegExp("^(4026|417500|4508|4844|491(3|7))");
        if( number.match(re) != null )
            return "Visa Electron";

        // Visa
        var re = new RegExp("^4");
        if( number.match(re) != null )
            return "Visa";

        // Mastercard
        re = new RegExp("^5[1-5]");
        if( number.match(re) != null )
            return "Mastercard";

        // Discover
        re = new RegExp("^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)");
        if( number.match(re) != null )
            return "Discover";

        return "";
    },

    handleMaskedNumberInputKey: function(e, mask) {
        CardJs.filterNumberOnlyKey(e);

        var keyCode = e.which || e.keyCode;

        var element = e.target;

        var caretStart = CardJs.caretStartPosition(element);
        var caretEnd = CardJs.caretEndPosition(element);


        // Calculate normalised caret position
        var normalisedStartCaretPosition = CardJs.normaliseCaretPosition(mask, caretStart);
        var normalisedEndCaretPosition = CardJs.normaliseCaretPosition(mask, caretEnd);


        var newCaretPosition = caretStart;

        var isNumber = CardJs.keyIsNumber(e);
        var isDelete = CardJs.keyIsDelete(e);
        var isBackspace = CardJs.keyIsBackspace(e);

        if( isNumber || isDelete || isBackspace ) {
            e.preventDefault();
            var rawText = $(element).val();
            var numbersOnly = CardJs.numbersOnlyString(rawText);

            var digit = CardJs.digitFromKeyCode(keyCode);

            var rangeHighlighted = normalisedEndCaretPosition > normalisedStartCaretPosition;

            // Remove values highlighted (if highlighted)
            if( rangeHighlighted ) {
                numbersOnly = (numbersOnly.slice(0, normalisedStartCaretPosition) + numbersOnly.slice(normalisedEndCaretPosition));
            }

            // Forward Action
            if( caretStart != mask.length ) {

                // Insert number digit
                if( isNumber && rawText.length <= mask.length ) {
                    numbersOnly = (numbersOnly.slice(0, normalisedStartCaretPosition) + digit + numbersOnly.slice(normalisedStartCaretPosition));
                    newCaretPosition = Math.max(
                        CardJs.denormaliseCaretPosition(mask, normalisedStartCaretPosition + 1),
                        CardJs.denormaliseCaretPosition(mask, normalisedStartCaretPosition + 2) - 1
                    );
                }

                // Delete
                if( isDelete ) {
                    numbersOnly = (numbersOnly.slice(0, normalisedStartCaretPosition) + numbersOnly.slice(normalisedStartCaretPosition + 1));
                }

            }

            // Backward Action
            if( caretStart != 0 ) {

                // Backspace
                if( isBackspace && !rangeHighlighted ) {
                    numbersOnly = (numbersOnly.slice(0, normalisedStartCaretPosition - 1) + numbersOnly.slice(normalisedStartCaretPosition));
                    newCaretPosition = CardJs.denormaliseCaretPosition(mask, normalisedStartCaretPosition - 1);
                }
            }

            $(element).val(CardJs.applyFormatMask(numbersOnly, mask));

            CardJs.setCaretPosition(element, newCaretPosition);

            return CardJs.applyFormatMask(numbersOnly, mask);
        } else {
            return $(element).val();
        }
    },

    getCardInfo: function(cardNumber) {
        let numberOnlyString = CardJs.numbersOnlyString(cardNumber),
            cardType = CardJs.cardTypeFromNumber(numberOnlyString);

        CardJs.updateCardTypeFromNumber(numberOnlyString);

        return CardJs.cardInfo[cardType];
    },

    updateCardTypeFromNumber: function(number) {
        let cardInfo = CardJs.cardInfo[CardJs.cardTypeFromNumber(number)];

        if( !_.isUndefined(cardInfo) ) {
            this.creditCardNumberMask = cardInfo.mask;
        } else {
            this.creditCardNumberMask = CardJs.CREDIT_CARD_NUMBER_DEFAULT_MASK;
        }
    }
}